export const introduce = {
  text: `### 指标用法
  + 交易所净流量可以很好的帮助我们洞察交易所资金流向，资金在牛市之前及牛市前期大量流出交易所，在牛市中后期再次流入交易所。

  ### 指标原理
  + 各大主流交易所流入与流出的差值，即交易所净流入/流出量。`,
  height: 1300,
};
